import * as React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import App from 'components/App'
import EmergencyApp from 'components/EmergencyApp'

import { Provider } from 'react-redux'
import {
  theme,
  Intercom,
  i18n,
  Loader,
  ThemeProvider,
  ErrorHandlerHoc,
} from 'sputnik-ui'
import { I18nextProvider } from 'react-i18next'
import { YMInitializer } from 'react-yandex-metrika'
import store from './store/store'

// service worker shows update msg
// import { showUpdateMessage } from 'store/ui/actions'
// import registerServiceWorker, { unregister } from './registerServiceWorker'

import 'rc-slider/assets/index.css'

function AppSwitcher() {
  const { location } = window
  const isEmergency = location.pathname.startsWith('/emergency_app')
  return isEmergency ? <EmergencyApp /> : <App />
}

const Root = () => (
  <Provider store={store}>
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <I18nextProvider i18n={i18n}>
          <React.Suspense fallback={<Loader fullPage />}>
            <AppSwitcher />
            <Intercom />
            <YMInitializer
              accounts={[108469576]}
              options={{
                clickmap: true,
                trackLinks: true,
                accurateTrackBounce: true,
                webvisor: false,
                trackHash: true,
              }}
            />
          </React.Suspense>
        </I18nextProvider>
      </ThemeProvider>
    </BrowserRouter>
  </Provider>
)

const node = document.getElementById('root')

if (node === null) {
  throw new Error('no node element')
}

ReactDOM.render(<Root />, node)

// const showUpdateToast = (action) => store.dispatch(showUpdateMessage(action))
// registerServiceWorker(showUpdateToast)

// unregister()
